import React, { useState, useEffect } from "react";
import { Row, Col, Form, Input, Tag, Typography } from "antd";
import AddPhysicianModalWrapper from "../../../modal/AddPhysicianModalWrapper";
import { physicianService } from "../../../../services/user";
import styled from "styled-components";
import { capitalizeFirstLetter } from "../../../../utils/utils";
import { extractToken } from "../../../../utils/localStorage";
import { globalRoles } from "../../../../utils/roles";

const { Title, Text, Paragraph } = Typography;

const FormContainer = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  width: 100%;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  /* &::-webkit-scrollbar-track {
    background:rgb(138, 136, 136);
    border-radius: 10px;
  } */

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
  .ant-typography-copy {
    color: #8a3ef4;
  }

  .formDetail {
    border: 1px solid var(--border-color);
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: start;
    font-size: 17px;
    color: var(--primary-text-color);
    font-weight: 600;
  }
  .ant-form-item-label > label {
    color: var(--secondary-text-color) !important;
  }
  .subHeading {
    color: var(--secondary-text-color);
    font-size: 16px;
    font-weight: 600;
  }
  .data {
    color: var(--primary-text-color);
    font-size: 16px;
    font-weight: 600;
    border: 1px solid var(--border-color);
    border-radius: 7px;
    margin-top: 9px;
    height: 41px;
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 0 10px;
    // background-color: var(--border-color);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

const PhysicianDetailModal = ({
  isOpen,
  setOpen,
  title,
  subtitle,
  DataById,
}) => {

  // console.log(DataById, "DataById")

  const user = extractToken();

  const [form] = Form.useForm();
  // useEffect(() => {
  //   if (DataById && Object.keys(DataById).length > 0) {
  //     form.setFieldsValue({
  //       // name: DataById.name,
  //       email: DataById.email,
  //       role: DataById.role,
  //       mobile: `${DataById.mobile?.countryCode || ""} ${
  //         DataById.mobile?.number || ""
  //       }`,
  //       specialty: DataById.specialty || "N/A",
  //       bloodGroup: capitalizeFirstLetter(DataById.bloodGroup) || "",
  //       country: DataById.country || "",
  //       state: DataById.state || "",
  //       city: DataById.city || "",
  //       status: DataById?.status ? "Active" : "Inactive",
  //       address: DataById.address || "",
  //     });
  //   }
  // }, [DataById, form]);

  return (
    <AddPhysicianModalWrapper
      show={isOpen}
      setShow={setOpen}
      title={
        <div className="row-flex flex-column">
          <h3 className="font-20 font-semibold text-primary mb-5">{title}</h3>
          <span className="font-15 text-secondry">{subtitle}</span>
        </div>
      }
      footer={null}
      width={620}
      keyClose={false}
      className="custom-detail-modal"
    >
      <Form form={form} layout="vertical" requiredMark="optional">
        <FormContainer>
          <Row gutter={[24, 16]}>
            <Col span={12}>
              <div className="subHeading">Full Name</div>
              <div className="data">
                {DataById?.name2 ? DataById?.name2 : capitalizeFirstLetter(DataById?.name)}
              </div>
            </Col>

             {DataById?.specialty && (
              <Col span={12}>
                <div className="subHeading">Specialty</div>
                <div className="data">{DataById?.specialty}</div>
              </Col>
            )}

            {DataById?.mobile && (
              <Col span={12}>
                <div className="subHeading">Phone Number</div>
                <div className="data">
                  {DataById.mobile?.countryCode || ""}{" "}
                  {DataById.mobile?.number || ""}
                </div>
              </Col>
            )}

            {/* <Col span={12}>
              <Form.Item
                name="role"
                label="Role"
                rules={[
                  { required: true, message: "Please input your email!" },
                ]}
              >
                <Input size="large" disabled />
              </Form.Item>
            </Col> */}

             <Col span={(DataById?.mobile || DataById?.specialty) ? 24 : 12}>
              <div className="subHeading">Email</div>
              <div className="data">{DataById?.email}</div>
            </Col>

            {DataById?.zip && (
             <Col span={12}>
              <div className="subHeading">Zip Code</div>
              <div className="data">{DataById?.zip}</div>
            </Col>
            )}

           {(user?.role === globalRoles.SUPERADMIN ||
            user?.role === globalRoles.LIBRARY_MANAGER
           ) && (
            <Col span={(DataById?.zip) ? 12 : 24}>
              <div className="subHeading">User Id</div>
              <div className="data">
                <Paragraph className="d-flex w-100 text-primary" copyable style={{marginBottom: 0, justifyContent: "space-between"}}>
                  {DataById?.id}
                </Paragraph>
              </div>
            </Col>
           )}

            {/* {DataById?.bloodGroup && (
              <Col span={12}>
                <div className="subHeading">Blood Group</div>
                <div className="data">
                  {capitalizeFirstLetter(DataById?.bloodGroup)}
                </div>
              </Col>
            )}

            {DataById?.city && (
              <Col span={12}>
                <div className="subHeading">City</div>
                <div className="data">{DataById?.city}</div>
              </Col>
            )}

            {DataById?.state && (
              <Col span={12}>
                <div className="subHeading">State</div>
                <div className="data">{DataById?.state}</div>
              </Col>
            )}

            {DataById?.country && (
              <Col span={12}>
                <div className="subHeading">Country</div>
                <div className="data">{DataById?.country}</div>
              </Col>
            )}

            <Col span={12}>
              <div className="subHeading">Status</div>
              <div className="data">
                {DataById?.status ? "Active" : "Inactive"}
              </div>
            </Col>

            {DataById?.address && (
              <Col span={24}>
                <div className="subHeading">Address</div>
                <div className="data">{DataById?.address}</div>
              </Col>
            )} */}

            {/* {DataById?.status && (
              <Col span={12}>
                <div className="subHeading">Status</div>
                <div className="data">{DataById?.status ? "Active" : "Inactive"}</div>
              </Col>
            )} */}
          </Row>
        </FormContainer>
      </Form>
    </AddPhysicianModalWrapper>
  );
};

export default PhysicianDetailModal;
